import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Customers from '@/pages/Customers';
import Sales from '@/pages/Sales';
import Payments from '@/pages/Payments';
import Import from '@/pages/Import';
import Outstanding from '@/pages/Outstanding';
import Settings from '@/pages/Settings';
import OrdersDispatch from '@/pages/OrdersDispatch';
import OrderSummary from '@/pages/OrderSummary';
import SalesTargets from '@/pages/SalesTargets';
import SingaporeInvite from '@/pages/SingaporeInvite';
import SingaporeInviteShare from '@/pages/SingaporeInviteShare';
import Layout from '@/components/Layout';
import AuthCallback from '@/components/AuthCallback';
import ProtectedRoute from '@/components/ProtectedRoute';
import ErrorBoundary from '@/components/ErrorBoundary';

function AppRouter() {
  const location = useLocation();
  
  // Check for session_token in URL fragment (from Google OAuth callback)
  if (location.hash?.includes('session_token=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Public conference invite — no auth required, page-by-page PDF */}
      <Route path="/sg" element={<SingaporeInvite />} />
      {/* Share-friendly landing — tap-to-open button + QR for cross-device */}
      <Route path="/sg/share" element={<SingaporeInviteShare />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/outstanding" element={<Outstanding />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/orders-dispatch" element={<OrdersDispatch />} />
        <Route path="/order-summary" element={<OrderSummary />} />
        <Route path="/sales-targets" element={<SalesTargets />} />
        <Route path="/import" element={<Import />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
